import script from "./FinanceInfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceInfoSection.vue?vue&type=script&setup=true&lang=js"

import "./FinanceInfoSection.vue?vue&type=style&index=0&id=5f12b10c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f12b10c"]])

export default __exports__